import styled from "styled-components";
import Button from "./Common/Button";
import { usePlayersContext, useSocketContext } from "./Common/Contexts";
import { useTranslationContext } from "../Hooks/useTranslationContext";
import { GameStatus } from "../Types/Game";

const Box = styled.div`
  padding: 1em;
  background: var(--color-bg-highlight);
  color: var(--color-text-light);
  border-radius: 0.8em;
  animation-iteration-count: 3;
  font-size: 1em;
  text-align: left;
`;
const Header = styled.div`
  font-weight: bold;
`;
const PlayersList = styled.div`
  padding: 1em 0px 1em 0px;
`;
const StyledButton = styled(Button)`
  margin-left: 1em;
`;

interface GameBoxProps {
  id: string;
  socketIds: string[];
  gameStatus: GameStatus;
}

const GameBox = ({ id, socketIds, gameStatus }: GameBoxProps) => {
  const socket = useSocketContext();
  const { t } = useTranslationContext();
  const { getSocketName, players } = usePlayersContext();

  const handleJoinGame = () => socket.emit("joinGame", id);
  const handleOnReconnect = (oldSocketId: string) =>
    socket.emit("reconnect", { gameId: id, socketId: oldSocketId });
  return (
    <Box>
      <Header>{`${t.game} ${id}`}</Header>
      <PlayersList>
        {socketIds.map((s) => (
          <div key={s}>
            <span>
              {getSocketName(s)}
              {gameStatus !== "won" && !players[s].isConnected && (
                <StyledButton
                  isSmall
                  isSecondary
                  onClick={() => handleOnReconnect(s)}
                >
                  {`${t["reconnect.as"]} ${getSocketName(s)}`}
                </StyledButton>
              )}
            </span>
          </div>
        ))}
      </PlayersList>
      <Button disabled={gameStatus === "won"} onClick={handleJoinGame}>
        {t.join}
      </Button>
    </Box>
  );
};

export default GameBox;
